module.exports = __webpack_public_path__ + "static/img/jp_zhsw.1a73b60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fajs/jp_zhsw.png
// module id = IRbQ
// module chunks = 1